var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.routeChildren.meta &&
    _vm.routeChildren.meta.isMenu &&
    !_vm.routeChildren.meta.isHidden
  )?_c('el-menu-item',{attrs:{"index":_vm.handlePath(_vm.routeChildren.path)},on:{"click":_vm.handleLink}},[_c('span',[_vm._v(_vm._s(_vm.routeChildren.meta.title))]),(_vm.routeChildren.meta && _vm.routeChildren.meta.badge)?_c('el-tag',{attrs:{"type":"danger","effect":"dark"}},[_vm._v(" "+_vm._s(_vm.routeChildren.meta.badge)+" ")]):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }